import { uniqBy, get } from 'lodash';

const normalizeDriveAndWheelTypes = (driveAndWheelTypes) => {
  const normalizedData = driveAndWheelTypes.map((driveAndWheelType) => {
    const {
      driveType,
      description,
      rearWheelType,
      dtd,
      msrp,
      label,
    } = driveAndWheelType;
    return {
      id: `${driveType}-${rearWheelType}`,
      driveType: driveType,
      rearWheelType: rearWheelType || '',
      description: description,
      label: label,
      option: { ...dtd, msrp: get(msrp, 'amount.value') },
    };
  });

  return uniqBy(normalizedData, 'id');
};

export default normalizeDriveAndWheelTypes;
